export const POPOUT_CONTAINER_PROFILE_CONFIGURATION = "popoutContainerConfigs";

/** Minumum window size for all Order/Deal Detail windows */
export const DETAILS_MIN_SIZE = { width: 830, height: 479 };
